<div class="flex-layout">
  <app-branding></app-branding>
  <mat-nav-list class="sidebar-list">
    <app-nav-item *ngFor="let item of navItems" [item]="item"> </app-nav-item>
  </mat-nav-list>
  <div *ngIf="showProButtons"
    class="pro absolute bottom-[40px] w-full h-[150px] flex flex-col items-end justify-end gap-2 pb-4 ml-2 cursor-pointer" (click)="redicionarMeuPlano()">
    <span class="text-white font-bold text-2xl pr-[30px]"> Quero s<span class="text-black">er</span> </span>
    <div class="flex items-center justify-start gap-2 bg-yellow-400 px-6 py-2 rounded-md cursor-pointer mr-4">
      <span class="text-white text-2xl font-bold">PRO!</span>
    </div>
  </div>
</div>
